import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { formatViews, getCategoryName, getLatestArticles, getTrendingArticles } from "@/lib/content";

export default function LatestStream() {
  const latest = getLatestArticles(7);
  const trending = getTrendingArticles(6);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="max-w-content mx-auto">
        <SectionHeading
          eyebrow="Just In"
          title="今日新瓜"
          desc="按时间顺序更新，越靠前越新鲜。想知道今天有什么瓜，从这里开始准没错。"
        />

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-300 ml-2">
              {latest.map((item, index) => (
                <li key={item.id} className="relative pl-6 md:pl-8 pb-6 last:pb-0">
                  <span
                    className={`absolute -left-[7px] top-1.5 w-3.5 h-3.5 rounded-full border-2 border-background-100 ${
                      index === 0 ? "bg-primary-500" : "bg-background-400"
                    }`}
                  ></span>
                  <div className="flex items-center gap-2 text-xs text-foreground-400">
                    <time>{item.publishedAt}</time>
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800">
                      {getCategoryName(item.category)}
                    </span>
                    {index === 0 && (
                      <span className="text-primary-600 font-medium">最新</span>
                    )}
                  </div>
                  <h3 className="mt-2 font-heading font-bold text-base md:text-lg text-foreground-950 leading-snug">
                    <Link
                      to={`/article/${item.id}`}
                      className="hover:text-primary-600 transition-colors"
                    >
                      {item.title}
                    </Link>
                  </h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.excerpt}
                  </p>
                  <div className="mt-2 flex items-center gap-4 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-3-line"></i>
                      {item.author}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {formatViews(item.views)}
                    </span>
                  </div>
                </li>
              ))}
            </ol>
            <Link
              to="/rank"
              className="mt-6 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-primary-300 text-primary-600 text-sm hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部新瓜
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
                  <i className="ri-fire-fill text-primary-500"></i>
                  热瓜榜
                </h3>
                <Link
                  to="/rank"
                  className="text-xs text-primary-600 hover:text-primary-700 whitespace-nowrap"
                >
                  完整榜单
                </Link>
              </div>
              <ul className="mt-4 divide-y divide-background-200">
                {trending.map((item, index) => (
                  <li key={item.id}>
                    <Link
                      to={`/article/${item.id}`}
                      className="group flex items-start gap-3 py-3 cursor-pointer"
                    >
                      <span
                        className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center text-xs font-bold ${
                          index < 3
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <span className="text-sm text-foreground-800 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                        {item.title}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}